import FitSVGText from '@/components/fit-svg-text/component'

export default {
  name: 'playful-poster',
  props: [ 'color' ],
  components: { FitSVGText },
  computed: {
    colorName () {
      if (this.color && this.color.name) {
        return this.color.name
      }
      return ''
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/posters/playful/script.js